import Quill from 'quill'

const Embed = Quill.import('blots/embed')

class MentionBlot extends Embed {
	static create(value) {
		const node = super.create()
		MentionBlot.buildSpan(value, node)
		return node
	}

	static value(node) {
		const { user: id, fullname, me } = node.dataset
		return { id, fullname, me }
	}

	static buildSpan({ id, fullname, me }, node) {
		if (me === 'true') {
			node.classList.add('mention-me')
		}
		const span1 = document.createElement('span')
		span1.className = 'mention-at'
		span1.innerText = '@'
		node.appendChild(span1)
		const span2 = document.createElement('span')
		span2.className = 'mention-name'
		span2.innerText = fullname
		Object.assign(node.dataset, {
			user: id,
			fullname,
			me,
		})
		node.appendChild(span2)
	}
}

MentionBlot.blotName = 'mention'
MentionBlot.tagName = 'span'
MentionBlot.className = 'quill-mention'

export default MentionBlot
